<template>
    <select>
        <option v-for="node in children" :key="node.id" 
            :value="node.id"
        >
            {{ node.layout.caption }}
        </option>
    </select>
</template>

<script>
import { gConsts } from '@/globals/gConsts';
import { mapGetters, mapState, mapActions } from 'vuex';
import { utils } from '@/globals/utils';

export default {
    name : 'layerSelectCMP',
    props: {
        children : Array,        
        parent   : Object,
        id       : String 
    }, 

    // -----------------------------------------------------------------

    data () {
        return {
        }
    },

    // -----------------------------------------------------------------

    computed: {
        ...mapState([
        ]),

        // -----------------------------------------------------------------


    },

    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
        ]),

        // -----------------------------------------------------------------

    },
}

</script>

// =========================================================================================
// =========================================================================================

<style>
li {
    font-size: 0.8em;
    left: 25px;
    margin-left: 5px;
    margin-top: 5px;
}

</style>